import { cn } from 'src/lib/utils';
import { portalDs } from 'src/components/portal-design-system';
import { formatRoundedMetric } from '../utils/user-journey.utils';
import type { UserJourneyMetrics } from '../types/user-journey.types';

interface JourneyMetricCardsProps {
  metrics: UserJourneyMetrics;
  showGenerationsWarning: boolean;
}

interface JourneyMetricCardProps {
  label: string;
  value: string;
  warning?: boolean;
}

function JourneyMetricCard({ label, value, warning = false }: JourneyMetricCardProps) {
  return (
    <div className="rounded-xl border border-[#EDEEF2] bg-white p-5 shadow-[0_1px_2px_rgba(13,15,26,0.05)]">
      <p className={cn(portalDs.caption, 'uppercase tracking-[0.5px]')}>{label}</p>
      <p
        className={cn(
          'mt-2 text-2xl font-bold tracking-[-0.8px]',
          warning ? 'text-[#D97706]' : 'text-[#0D0F1A]',
        )}
      >
        {value}
      </p>
    </div>
  );
}

export function JourneyMetricCards({ metrics, showGenerationsWarning }: JourneyMetricCardsProps) {
  return (
    <div className="grid grid-cols-1 gap-3 sm:grid-cols-2 xl:grid-cols-4">
      <JourneyMetricCard
        label="Sessions"
        value={formatRoundedMetric(metrics.sessions)}
      />
      <JourneyMetricCard
        label="Generations"
        value={formatRoundedMetric(metrics.generations)}
      />
      <JourneyMetricCard
        label="Downloads"
        value={formatRoundedMetric(metrics.downloads)}
      />
      <JourneyMetricCard
        label="Generations per download"
        value={formatRoundedMetric(metrics.generations_per_download)}
        warning={showGenerationsWarning}
      />
    </div>
  );
}
